import { ICounterProps } from "./interface";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

const CounterField: React.FC<ICounterProps> = ({ count, onIncrement, onDecrement, disabled = false }) => {
  const handleIncrement = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (disabled) return;
    onIncrement();
  };

  const handleDecrement = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (disabled) return;
    onDecrement();
  };

  return (
    <div
      className={clsx(
        "grow shrink basis-0 h-9 pl-2 pr-1.5 py-2 rounded-md border border-slate-400 border-opacity-20 justify-start items-center gap-2 flex",
        disabled ? "bg-gray-50 opacity-60 cursor-not-allowed" : "bg-white",
      )}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={(e) => {
          handleDecrement(e);
        }}
      >
        <MinusIcon className="w-4 h-4" />
      </button>
      <div className="w-[76px] text-center text-black text-xs font-normal leading-tight tracking-wide">
        {count ? count : 0}
      </div>
      <button
        type="button"
        disabled={disabled}
        onClick={(e) => {
          handleIncrement(e);
        }}
      >
        <PlusIcon className="w-4 h-4" />
      </button>
    </div>
  );
};

export default CounterField;
